import React, { useState } from "react";
import moment from "moment";

import { useOnboardingContext } from "../OnboardingApp";
import { filterGroups } from "../checklistFilters";
import ChecklistGroup from "./ChecklistGroup";
import CalendarCheckIcon from "../../shared/Icons/CalendarCheckIcon";

const TABS = [
  { key: "all", label: "All tasks" },
  { key: "opendate", label: "Opendate's" },
  { key: "overdue", label: "Overdue" },
  { key: "completed", label: "Completed" },
];

const OnboardingChecklist = () => {
  const { checklist } = useOnboardingContext();
  const [filter, setFilter] = useState("all");

  if (!checklist) {
    return (
      <div className="onboarding-page">
        <div className="onboarding-alert" role="status">
          <span className="onboarding-alert-icon">
            <CalendarCheckIcon fill="currentColor" width="16" height="16" />
          </span>
          <div className="onboarding-alert-content">
            <span className="onboarding-alert-title">Your onboarding checklist isn't ready yet</span>
            <span className="onboarding-alert-desc">
              We're still setting things up. Check back soon, or reach out to your Opendate contact.
            </span>
          </div>
        </div>
      </div>
    );
  }

  const { account, groups } = checklist;
  const visibleGroups = filterGroups(groups, filter);
  const totalTasks = groups.reduce((sum, group) => sum + group.total, 0);
  const completeTasks = groups.reduce((sum, group) => sum + group.complete, 0);
  const overdueCount = account.overdue_count;

  return (
    <div className="onboarding-page">
      <div className="onboarding-header">
        <div className="onboarding-header-titles">
          <h1 className="onboarding-title">Onboarding</h1>
          <span className="onboarding-subtitle">
            Track your team's progress getting set up on Opendate.
          </span>
        </div>
        <div className="onboarding-header-meta">
          <div className="onboarding-progress">
            <div className="onboarding-progress-labels">
              <span className="onboarding-progress-count">{completeTasks} of {totalTasks} complete</span>
              <span className="onboarding-progress-pct">{account.percent_complete}%</span>
            </div>
            <div className="onboarding-progress-track">
              <div className="onboarding-progress-fill" style={{ width: `${account.percent_complete}%` }} />
            </div>
          </div>
          {account.golive_on && (
            <span className="onboarding-golive-chip">
              <CalendarCheckIcon fill="currentColor" width="16" height="16" />
              <span className="onboarding-golive-label">Target go-live</span>
              <span className="onboarding-golive-date">{moment(account.golive_on).format("MMM D")}</span>
            </span>
          )}
        </div>
      </div>

      <div className="onboarding-tabs" role="tablist" aria-label="Onboarding task filters">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={filter === tab.key}
            className={`onboarding-tab ${filter === tab.key ? "onboarding-tab-active" : ""}`}
            onClick={() => setFilter(tab.key)}
          >
            {tab.label}
            {tab.key === "overdue" && overdueCount > 0 && (
              <span className="onboarding-tab-badge">{overdueCount}</span>
            )}
          </button>
        ))}
      </div>

      <div className="onboarding-card">
        {visibleGroups.map((group) => (
          <ChecklistGroup key={group.name} group={group} />
        ))}
        {visibleGroups.length === 0 && (
          <div className="onboarding-empty">
            <span className="onboarding-empty-title">Nothing here</span>
            <span className="onboarding-empty-sub">No tasks match this filter.</span>
          </div>
        )}
      </div>
    </div>
  );
};

OnboardingChecklist.propTypes = {};

export default OnboardingChecklist;
